import React from 'react';

type UserRolesTabProps = {
  info: string;
};

function UserRolesTab({ info }: UserRolesTabProps) {
  return <div className="" />;
}

export default UserRolesTab;
